import React from 'react';
import { ReservationData } from './ReservationForm';

interface ConfirmationProps {
  reservation: ReservationData;
  onNewReservation: () => void;
}

const Confirmation: React.FC<ConfirmationProps> = ({ reservation, onNewReservation }) => {
  return (
    <div className="confirmation-container">
      <div className="confirmation-card">
        <h2>Reservation Confirmed!</h2>
        <div className="confirmation-icon">✓</div>
        <p className="confirmation-message">
          Thank you for your reservation at SMSushi. We look forward to serving you!
        </p>

        <div className="reservation-details">
          <h3>Reservation Details</h3>

          <div className="detail-row">
            <span className="detail-label">Name:</span>
            <span className="detail-value">{reservation.name}</span>
          </div>

          <div className="detail-row">
            <span className="detail-label">Table:</span>
            <span className="detail-value">{reservation.tableId}</span>
          </div>

          <div className="detail-row">
            <span className="detail-label">Date:</span>
            <span className="detail-value">{reservation.date}</span>
          </div>

          <div className="detail-row">
            <span className="detail-label">Time:</span>
            <span className="detail-value">{reservation.time}</span>
          </div>

          <div className="detail-row">
            <span className="detail-label">Guests:</span>
            <span className="detail-value">{reservation.guests}</span>
          </div>

          {reservation.specialRequests && (
            <div className="detail-row">
              <span className="detail-label">Special Requests:</span>
              <span className="detail-value">{reservation.specialRequests}</span>
            </div>
          )}
        </div>

        <div className="confirmation-footer">
          <p>A confirmation email has been sent to {reservation.email}</p>
          <p>If you need to modify or cancel your reservation, please call us at (555) 123-4567</p>
        </div>

        <button className="new-reservation-button" onClick={onNewReservation}>
          Make Another Reservation
        </button>
      </div>
    </div>
  );
};

export default Confirmation; 